import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { emitUIEvent } from '@montugroup/data-collection';
import { useEffect } from 'react';
import { ActiveOrdersView } from './components/ActiveOrdersView';
export const CUSTOM_CHATBOT_COMPONENTS = {
    ActiveOrders: ActiveOrdersView,
};
/**
 * A wrapper component that emits an event for any dynamically rendered component from the chatbot.
 *
 * @param props - The props for the component.
 * @returns The rendered component.
 */
const ParsedComponent = (props) => {
    const { name, Component, componentProps } = props;
    useEffect(() => {
        emitUIEvent({
            component_name: name,
            event_name: 'view',
            id: `analytics-view-${name.replace(/(?<!^)(?=[A-Z])/g, '-').toLowerCase()}`,
        }, []);
    }, [name]);
    return _jsx(Component, { ...componentProps });
};
/**
 * Parses a string message and returns a trackable React Element.
 *
 * @param message - The string message received from the chatbot backend.
 * @returns A ReactElement if a custom component is parsed successfully, otherwise null.
 */
export const parseCustomComponent = (message) => {
    try {
        const parsedObject = JSON.parse(message);
        if (parsedObject && parsedObject.type === 'component' && parsedObject.name) {
            const { name } = parsedObject;
            const props = {
                data: parsedObject.data,
                message: parsedObject.message,
            };
            const ComponentToRender = CUSTOM_CHATBOT_COMPONENTS[name];
            if (ComponentToRender) {
                return _jsx(ParsedComponent, { name: name, Component: ComponentToRender, componentProps: props });
            }
        }
    }
    catch {
        return null;
    }
    return null;
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiUGFyc2VkQ29tcG9uZW50LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvUGFyc2VkQ29tcG9uZW50L1BhcnNlZENvbXBvbmVudC50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBLE9BQU8sRUFBRSxXQUFXLEVBQUUsTUFBTSw2QkFBNkIsQ0FBQztBQUUxRCxPQUFPLEVBQUUsU0FBUyxFQUFFLE1BQU0sT0FBTyxDQUFDO0FBQ2xDLE9BQU8sRUFBRSxnQkFBZ0IsRUFBRSxNQUFNLCtCQUErQixDQUFDO0FBSWpFLE1BQU0sQ0FBQyxNQUFNLHlCQUF5QixHQUE4RDtJQUNsRyxZQUFZLEVBQUUsZ0JBQXdFO0NBQ3ZGLENBQUM7QUFRRjs7Ozs7R0FLRztBQUNILE1BQU0sZUFBZSxHQUFHLENBQUMsS0FBMkIsRUFBRSxFQUFFO0lBQ3RELE1BQU0sRUFBRSxJQUFJLEVBQUUsU0FBUyxFQUFFLGNBQWMsRUFBRSxHQUFHLEtBQUssQ0FBQztJQUVsRCxTQUFTLENBQUMsR0FBRyxFQUFFO1FBQ2IsV0FBVyxDQUNUO1lBQ0UsY0FBYyxFQUFFLElBQUk7WUFDcEIsVUFBVSxFQUFFLE1BQU07WUFDbEIsRUFBRSxFQUFFLGtCQUFrQixJQUFJLENBQUMsT0FBTyxDQUFDLGtCQUFrQixFQUFFLEdBQUcsQ0FBQyxDQUFDLFdBQVcsRUFBRSxFQUFFO1NBQzVFLEVBQ0QsRUFBRSxDQUNILENBQUM7SUFDSixDQUFDLEVBQUUsQ0FBQyxJQUFJLENBQUMsQ0FBQyxDQUFDO0lBRVgsT0FBTyxLQUFDLFNBQVMsT0FBSyxjQUFjLEdBQUksQ0FBQztBQUMzQyxDQUFDLENBQUM7QUFFRjs7Ozs7R0FLRztBQUNILE1BQU0sQ0FBQyxNQUFNLG9CQUFvQixHQUFHLENBQUMsT0FBZSxFQUE2QixFQUFFO0lBQ2pGLElBQUksQ0FBQztRQUNILE1BQU0sWUFBWSxHQUFHLElBQUksQ0FBQyxLQUFLLENBQUMsT0FBTyxDQUFDLENBQUM7UUFFekMsSUFBSSxZQUFZLElBQUksWUFBWSxDQUFDLElBQUksS0FBSyxXQUFXLElBQUksWUFBWSxDQUFDLElBQUksRUFBRSxDQUFDO1lBQzNFLE1BQU0sRUFBRSxJQUFJLEVBQUUsR0FBRyxZQUFZLENBQUM7WUFDOUIsTUFBTSxLQUFLLEdBQUc7Z0JBQ1osSUFBSSxFQUFFLFlBQVksQ0FBQyxJQUFJO2dCQUN2QixPQUFPLEVBQUUsWUFBWSxDQUFDLE9BQU87YUFDOUIsQ0FBQztZQUVGLE1BQU0saUJBQWlCLEdBQUcseUJBQXlCLENBQUMsSUFBSSxDQUFDLENBQUM7WUFFMUQsSUFBSSxpQkFBaUIsRUFBRSxDQUFDO2dCQUN0QixPQUFPLEtBQUMsZUFBZSxJQUFDLElBQUksRUFBRSxJQUFJLEVBQUUsU0FBUyxFQUFFLGlCQUFpQixFQUFFLGNBQWMsRUFBRSxLQUFLLEdBQUksQ0FBQztZQUM5RixDQUFDO1FBQ0gsQ0FBQztJQUNILENBQUM7SUFBQyxNQUFNLENBQUM7UUFDUCxPQUFPLElBQUksQ0FBQztJQUNkLENBQUM7SUFDRCxPQUFPLElBQUksQ0FBQztBQUNkLENBQUMsQ0FBQyJ9